import React, { useState, useEffect } from "react";
// import { Card } from "react-bootstrap";
// import banner from "../assets/Home/job.png"
// import banner1 from "../assets/Home/job2.png"
// import slider1 from "../assets/Home/slider4.jpg"
// import slider2 from "../assets/Home/slider5.png"
// import slider3 from "../assets/Home/slider1.jpg"
// import slider4 from "../assets/Home/college.jpg"
// import slider5 from "../assets/Home/slider2.jpg"
import CardsLinks from "./Home/CardLinks";
import n1 from "../assets/Home/n1.jpeg";
import n2 from "../assets/Home/n2.jpeg";
import n3 from "../assets/Home/n3.jpeg";
import n4 from "../assets/Home/n4.jpeg";
import n5 from "../assets/Home/n5.jpeg";
import n6 from "../assets/Home/n6.jpeg";
import NewsFeed from "./Home/News";
import Photo from "./Gallery/Photo";
// import n7 from "../assets/Home/n7.jpeg"

export default function HomePage() {
  // Use a single state variable for the current image index
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      src: n1,
      alt: "Cultural celebration image 1",
    },
    {
      src: n2,
      alt: "Cultural celebration image 2",
      onerror: "this.src='../assets/Home/slider5.png';",
    },
    {
      src: n3,
      alt: "Cultural celebration image 3",
    },
    {
      src: n4,
      alt: "Cultural celebration image 4",
    },
    {
      src: n5,
      alt: "Cultural celebration image 5",
    },
  ];

  const Section = ({ title, items, linkText }) => (
    <></>
    // <section className="flex flex-col space-y-4">
    //   <div className="bg-red-600 text-white font-bold py-2 px-4 inline-block mb-4 rounded-md shadow-md">
    //     {title}
    //   </div>
    //   <div className="bg-white shadow-lg rounded-lg p-6 space-y-6">
    //     {items.map((item, index) => (
    //       <div key={index} className="space-y-2">
    //         <h3 className="font-bold text-lg">
    //           {item.heading}
    //           {item.badge && (
    //             <span className="ml-2 text-sm text-red-600 bg-red-200 px-2 py-1 rounded">
    //               {item.badge}
    //             </span>
    //           )}
    //         </h3>
    //         <p className="text-gray-600">{item.subtitle}</p>
    //         {item.description && <p className="text-gray-700">{item.description}</p>}
    //         {item.link && (
    //
    //             href={item.link.href}
    //             className="text-blue-600 hover:underline text-sm"
    //           >
    //             {item.link.text}
    //           </a>
    //         )}
    //       </div>
    //     ))}
    //     {linkText && (
    //       <a href="#" className="text-blue-600 hover:underline font-bold">
    //         {linkText}
    //       </a>
    //     )}
    //   </div>
    // </section>
  );

  // Navigation functions for the slider
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % sliders.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + sliders.length) % sliders.length);
  };

  const sliders = [n1, n2, n3, n5, n6]; // Add all image paths here

  // Auto-rotate images every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliders.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [sliders.length]);

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="mx-auto border-gray-500">
        {/* Carousel */}
        <div className="relative overflow-hidden">
          <div className="w-full">
            <img
              src={sliders[currentIndex]}
              alt={`Slide ${currentIndex + 1}`}
              className="w-full h-[600px] object-cover" // Fixed height with object-cover
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "../assets/Home/slider5.png";
              }}
            />
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-700 bg-opacity-50 text-white rounded-full p-2 focus:outline-none hover:bg-opacity-70"
          >
            ❮
          </button>
          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-700 bg-opacity-50 text-white rounded-full p-2 focus:outline-none hover:bg-opacity-70"
          >
            ❯
          </button>

          {/* Original commented navigation buttons */}
          {/* <button
          onClick={prevSlide}
          className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-700 text-white rounded-full p-2 focus:outline-none"
        >
          ❮
        </button>
        <button
          onClick={nextSlide}
          className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-700 text-white rounded-full p-2 focus:outline-none"
        >
          ❯
        </button> */}
        </div>

        {/* Indicators */}
        <div className="flex justify-center space-x-2 mt-4">
          {sliders.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-2 w-2 rounded-full ${
                index === currentIndex ? "bg-gray-800" : "bg-gray-400"
              }`}
            ></button>
          ))}
        </div>
        {/* 
      <div className="py-2 text-center text-muted">
        Slide {current + 1} of {images.length}
      </div> */}
      </div>
      <div class="md:ml-8  border-l-4 border-orange-500 pl-4">
        <div class="ml-1 text-lg font-semibold text-gray-700">About Us</div>
      </div>
      <div class="flex flex-col md:flex-row items-start md:items-center md:mb-8">
        <div class="h-[30vh] overflow-y-auto p-6 w-full md:w-8/12 lg:w-6/12 mx-auto ml-0 md:ml-4">
          <p class="text-gray-800 text-base md:text-lg">
            Government Women's Polytechnic College is located in Sehore and
            affiliated with Rajiv Gandhi Proudyogiki Vishwavidyalaya. The
            college is identified by its innovation and openness in the
            educational system by engaging students to participate in debate and
            development, resulting in vast opportunities through quality
            education.
          </p>

          <p class="mt-4 text-gray-800 text-base md:text-lg">
            मध्यप्रदेश शासन तकनीकी शिक्षा विभाग डॉ बाबासाहेब आंबेडकर योजना
            अंतर्गत संचालित शासकीय महिला पॉलिटेक्निक महाविद्यालय सीहोर में
            अनुसूचित जाति वर्ग की छात्राओं के तीन वर्षीय पाठ्यक्रम कंप्यूटर
            साइंस एवं इंजीनियरिंग और मॉडर्न ऑफिस मैनेजमेंट में निशुल्क प्रवेश
            प्रक्रिया एमपी ऑनलाइन के माध्यम से शुरू की जाती है।
          </p>
        </div>
        {/* <div class="border border-gray-400 p-4 w-full md:w-4/12 lg:w-3/12 mx-auto mt-4 md:mt-0 md:ml-6 relative text-center">
          <span class="absolute -top-3 left-4 text-2xl text-gray-400">&#10077;</span>
          <p class="text-gray-700 italic">"Education is transmission of civilisation"</p>
          <span class="absolute -bottom-5 right-4 text-2xl text-gray-400">&#10078;</span>
        </div> */}
        <div className="w-1/3">
          <NewsFeed />
        </div>
      </div>

      {/* <div className="flex flex-wrap justify-center items-center w-full gap-6 p-6">
        
        <div className="flex bg-white px-4 justify-center w-full md:w-auto">
          <img
            className="h-70 w-auto rounded shadow-md border border-gray-300"
            src={banner1}
            alt="Image 1"
          />
        </div>

         
        <div className="flex justify-center w-full md:w-auto">
          <img
            className="max-h-[500px] w-auto h-auto rounded shadow-md border border-gray-300"
            src={banner}
            alt="Image 2"
          />
        </div>
      </div> */}
      {/* <Photo/> */}
      <CardsLinks />

      <div className="container mx-auto p-12 mt-10 overflow-hidden relative">
        {/* Main Wrapper */}
        {/* <div className="h-[80vh] w-full rounded-lg relative overflow-hidden"> */}
        {/* Carousel Wrapper */}
        {/* <div
            className="flex flex-col space-y-6 absolute w-full animate-carousel"
            style={{
              animation: "carousel 25s linear infinite",
            }}
          > */}
        {/* Tender Notice Section */}
        {/* <Section
              title="TENDER NOTICE"
              items={[
                {
                  heading: "Notice regarding Tender Opening for Book Purchase",
                  subtitle: "Notice Document",
                  badge: "new",
                },
                {
                  heading: "Tender information for Books purchase",
                  subtitle: "Last Date of Submission: 9/9/2024 till 12 PM",
                },
              ]}
              linkText="View All Tenders"
            /> */}

        {/* College Notice Section */}
        {/* <Section
              title="COLLEGE NOTICE"
              items={[
                {
                  heading: "Group Insurance Policy 2020-21 for students by RGPV",
                  subtitle: "Updated policy information",
                },
                {
                  heading:
                    "Beneficiary Students under AICTE-Pragati Scholarship Scheme (Diploma) Academic Year 2021-22",
                  subtitle: "List of eligible students",
                },
              ]}
              linkText="View All Notices"
            /> */}

        {/* Featured News Section */}
        <Section
          title="FEATURED NEWS"
          items={[
            {
              heading: "Workshop on Business Communication & Resume Writing",
              subtitle: "Posted on October, 22 / 2024",
              description:
                "An Interactive Workshop on Business Communication ...",
              link: { text: "Click Here To Download PDF Document", href: "#" },
            },
            {
              heading: "Annual Tech Fest Announcement",
              subtitle: "Posted on October, 25 / 2024",
              description: "Join us for our annual technology festival ...",
            },
          ]}
          linkText="View All News"
        />

        {/* Local Expert Pool Section */}
        {/* <Section
              title="Local Expert Pool"
              items={[
                {
                  heading: "Main List: Department Wise Pool of Local Experts",
                  link: { text: "View List", href: "#" },
                },
                {
                  heading: "Department Activity Calendar of Local Expert",
                  link: { text: "View Calendar", href: "#" },
                },
                {
                  heading: "Departments",
                  description: "1) ETE Department\n2) CSE Department\n3) AID Department\n4) FT Department\n5) MOM Department",
                },
              ]}
            /> */}

        {/* Related Links Section */}
        {/* <Section
              title="Related Links"
              items={[
                {
                  heading: "Online Link - Youth4work ( Get Jobs and Internships )",
                  badge: "new",
                },
                {
                  heading: "Assessment Test Registration",
                  badge: "new",
                },
                {
                  heading:
                    "Registration Link - Five days DTE sponsored FDP on Geographical Information System (GIS)",
                  badge: "new",
                },
              ]}
              linkText="More Links"
            /> */}

        {/* YouTube Links Section */}
        {/* <Section
              title="YouTube Links"
              items={[
                {
                  heading:
                    "Webinar on Managing Effective Technical Education Post Covid 19",
                  link: { text: "Play Link", href: "#" },
                },
                {
                  heading: "Introduction to Machine Learning",
                  link: { text: "Watch Video", href: "#" },
                },
              ]}
            /> */}

        {/* Webinar Links Section */}
        {/* <Section
              title="Webinar Links"
              items={[
                {
                  heading:
                    "To View all Webinar conducted during COVID-19 Lockdown Period, Please Click Here",
                  link: { text: "View Webinars", href: "#" },
                },
                {
                  heading: "Upcoming Webinar: Future of AI in Education",
                  link: { text: "Register Now", href: "#" },
                },
              ]}
            /> */}
        {/* </div>
        </div> */}

        <style>
          {`
      @keyframes carousel {
        0% { transform: translateY(0); }
        100% { transform: translateY(-50%); }
      }
      .animate-carousel {
        animation: carousel 60s linear infinite;
      }
    `}
        </style>

        <div className="mt-10">
          <Photo />
        </div>
      </div>
    </div>
    // </div>
  );
}
